import BrowseNotificationLogsStore from "@/areas/workflows/stores/BrowseNotificationLogsStore";

export default class WorkflowRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.browseNotificationLogsStore = new BrowseNotificationLogsStore(this);
  }
}
